import React from "react";
import KitchenDashboard from "./KitchenDashboard";

const FoodKitchen = () => <KitchenDashboard kitchenType="food" />;

export default FoodKitchen;
